import { tonightDramas } from '@/mocks/dramas';

const statusStyle = (s: string) => {
  if (s === '今晚大结局') return 'bg-[#e85d3f] text-white';
  if (s === '已完结') return 'bg-[#8b9d6b] text-white';
  return 'bg-[#3e7c59] text-white';
};

export default function Tonight() {
  return (
    <section id="tonight" className="scroll-mt-20 bg-[#faf6ef] py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#e85d3f]">
              <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-[#e85d3f]"></span>
              今晚最新剧情在线抢先看
            </p>
            <h2 className="font-serif-sc text-2xl font-black text-[#26201a] md:text-3xl">今晚更新 · 抢先看</h2>
          </div>
          <a href="#calendar" className="text-sm font-medium text-[#6f655a] hover:text-[#e85d3f]">
            查看完整日历 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {tonightDramas.map((d) => (
            <article
              key={d.id}
              className="group flex overflow-hidden rounded-2xl border border-[#26201a]/8 bg-white transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative w-[38%] shrink-0 overflow-hidden">
                <img src={d.img} alt={`${d.title} ${d.updateTo}`} className="h-full w-full object-cover object-top" />
                <span className={`absolute left-2 top-2 rounded-full px-2.5 py-1 text-[10px] font-bold ${statusStyle(d.status)}`}>
                  {d.status}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="mb-1.5 flex items-center gap-2">
                  <span className="rounded-md bg-[#f3ecdf] px-2 py-0.5 text-[10px] font-semibold text-[#8a6d3b]">{d.tag}</span>
                  <span className="text-[11px] text-[#a3988a]">{d.updateTo}</span>
                </div>
                <h3 className="mb-2 font-serif-sc text-lg font-black leading-snug text-[#26201a]">{d.title}</h3>
                <p className="line-clamp-3 text-xs leading-6 text-[#6f655a]">{d.desc}</p>
                <div className="mt-auto flex items-center justify-between pt-3 text-[11px] text-[#a3988a]">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {d.heat}人围观
                  </span>
                  <a href="#guide" className="flex items-center gap-0.5 font-semibold text-[#e85d3f] hover:underline">
                    看速递 <i className="ri-arrow-right-s-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}